export const LIST_ITEM_COPY = {
  NO_POLICY: 'No Policy',
  NOT_LINKED: 'Not Linked',
  NO_FRAMEWORK: 'No Framework',
  NOT_APPLICABLE_POLICY: 'N/A Policy',
}
